import createInterface from '@/utils/axios';

interface IsUserInWhiteListRsp {
    isExist: boolean;
}

export const isUserInWhiteListApi = createInterface<
    void,
    IsUserInWhiteListRsp
>('GET', '/api/csm/whiteList/check');

export const isUserInCseWhiteListApi = createInterface<
    {featureType: string},
    IsUserInWhiteListRsp
>('GET', '/api/cse/v1/whiteList/check');
